import { LoretaMode } from "../services/types/device.types";

/**
 * LORETA protocol catalogs, as supplied by the research institute. These are canonical
 * clinical terms and are intentionally NOT translated.
 */

export const LORETA_SYMPTOMS = [
  "Anosognosia - Denial of a Problem",
  "Anxiety",
  "Attention Deficits - Easily Distractible",
  "Auditory Sequencing Problems",
  "Autism Spectrum Disorder",
  "Balance Problems",
  "Blurred Vision",
  "Chronic Pain",
  "Compulsive Behaviors and/or Thoughts",
  "Concentration Problems",
  "Decreased Tactile or Skin Sensitivity",
  "Delusional",
  "Depression (Sad & Blue)",
  "Difficulty Comprehending Social Cues",
  "Dyscalcula - Problems Calculating",
  "Dyslexia - Letter Reversal",
  "Executive Function Problems",
  "Face Recognition Problems",
  "Failure to Initiate Actions",
  "Hyperactive and/or Agitation",
  "Impulsive Behaviors",
  "Insensitive to Others Emotional Expressions",
  "Insensitive to Other's Feelings",
  "Low Motivation",
  "Low Threshold for Anger & Loss of Control",
  "Migrane Headaches",
  "Mood Swings",
  "Multi-Tasking Problems",
  "Obsessive Thoughts about Self",
  "Obsessive Thoughts and/or Hyper Focused",
  "Oppositional Defiant Conduct",
  "Orientation in Space Problems",
  "Perception of Letters Problems",
  "Poor Judgement",
  "Poor Skilled Motor Movements",
  "Poor Social Skills",
  "Receptive Language Problems",
  "Recognizing Objects by Touch Problems",
  "Self-Esteem Problems",
  "Sequential Planning Problems",
  "Short-Term Memory Problems",
  "Slow Reader",
  "Slowness of Thought - Easily Confused",
  "Spatial Perception Problems",
  "Speech Articulation Problems",
  "Substance Abuse",
  "Symptoms of Fibromyalgia",
  "Tinnitus",
  "Word Finding Problems",
] as const;

export const LORETA_NETWORKS = [
  "Addiction",
  "Anxiety",
  "Attention - Dorsal",
  "Attention - Ventral",
  "Attention - Emotional",
  "Autism Spectrum Disorder",
  "Default Mode",
  "Executive Function",
  "Face, Object Recognition",
  "Language",
  "Memory - Emotion",
  "Mirror Neuron",
  "Mood",
  "Pain",
  "Pleasure",
  "Salience",
  "Schizophrenia",
  "Tinnitus",
  "Working Memory",
  "DTI - Frontal Limbic",
  "DTI - Frontal Occipital",
  "DTI - Frontal Parietal",
  "DTI - Frontal Temporal",
  "DTI - Isocortex Hippocampocentric",
  "DTI - Isocortex Olfactocentric",
  "DTI - Local Frontal",
  "DTI - Local Limbic",
  "DTI - Local Occipital",
  "DTI - Local Parietal",
  "DTI - Local Temporal",
  "DTI - Mesocortex Hippocampocentric",
  "DTI - Mesocortex Olfactocentric",
  "Hagmann Module 1 (Vision)",
  "Hagmann Module 2 (Attention, Working Memory)",
  "Hagmann Module 3 (Auditory, Language, Memory)",
  "Hagmann Module 4 (Auditory, Language, Memory)",
  "Hagmann Module 5 (Executive, Sequential Planning)",
  "Hagmann Module 6 (Executive, Social Skills)",
  "Mesulam - Emotional Memory",
  "Mesulam - Executive Function",
  "Mesulam - Face/Object Indentification",
  "Mesulam - Language",
  "Mesulam - Spatial Attention",
] as const;

export const LORETA_DOD_VA = [
  "Attention - Re-Experiences Intrusive Memories",
  "Attention - Emotional Numbing",
  "Attention - Distracting Pain",
  "Attention - Difficulty Multi-Tasking",
  "Attention - Worsens with Emotional Stress",
  "Attention - Dissociative Episodes",
  "Attention - Worsens With Withdrawl Symptoms",
  "Chronic Pain - Neuropathic",
  "Chronic Pain - Musculoskeletal",
  "Chronic Pain - Diffuse Pain (Entire Body)",
  "Chronic Pain - Pain Triggers Memories of Trauma",
  "Mood - Emotional Numbing",
  "Mood - Irritability",
  "Mood - Emotional Fatigue",
  "Mood - Physical Fatigue",
  "Mood - Lack of Enjoyment in Most Daily Activities",
  "Mood - Impulsivity",
  "Mood - Activities Driven by Medication Needs",
  "Mood - Hyperarousal",
  "Concussion - Difficulty Multi-Tasking",
  "Concussion - Short-Term Memory Problems",
  "Concussion - Difficulty Concentrating",
  "Concussion - Sleep Problems",
  "Concussion - Balance Problems",
  "Concussion - Problems Controlling Anger",
  "Concussion - Depressed Mood",
  "PTSD - Hyperarousal",
  "PTSD - Sudden Fear Reactions",
  "PTSD - Excessive Sleep-Lethargic",
  "PTSD - Difficulty Falling Asleep Due to Ruminations",
  "PTSD - Mood Disorders",
  "Sleep - Fear of Sleep Due to Nightmares",
  "Sleep - Difficulty Falling Asleep Due to Ruminations",
  "Sleep - Diffculty with Sleep Due to Withdrawl Symptoms",
  "Sleep - Early AM/Night Time Awakening (Unexplained)",
] as const;

export const LORETA_MODES: { value: LoretaMode; labelKey: string }[] = [
  { value: "symptoms", labelKey: "LORETA_MODE_SYMPTOMS" },
  { value: "networks", labelKey: "LORETA_MODE_NETWORKS" },
  { value: "dodva", labelKey: "LORETA_MODE_DODVA" },
];

export const LORETA_OPTIONS: Record<LoretaMode, readonly string[]> = {
  symptoms: LORETA_SYMPTOMS,
  networks: LORETA_NETWORKS,
  dodva: LORETA_DOD_VA,
};
